import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import * as Classes from "../../../classes/index"
import { updateArray } from "../../../helpers/index";
import { IWaiver, defaultWaiver, IFormAnswer } from "../../../classes/index";

export interface StepFourModel {
    mediaRelease: IWaiver;
    liability: IWaiver;
    fieldTripPermission: IWaiver;
    emergencyRoomRelease: IWaiver;
    wellChild: IWaiver;
}

export const defaultStepFourModel: StepFourModel = {
    mediaRelease: defaultWaiver,
    emergencyRoomRelease: defaultWaiver,
    fieldTripPermission: defaultWaiver,
    liability: defaultWaiver,
    wellChild: defaultWaiver
};

export default function stepFourReducer(state: StepFourModel = defaultStepFourModel, action: IAction) {
    switch (action.type) {
        case ActionType.SAVE_WAIVER_INITIALS: {
            let data = action.value as IFormAnswer;

            let updatedWaiver = _.assign({}, state[data.id], { initials: data.value });

            return _.assign({}, state, {
                [data.id]: updatedWaiver
            });
        }
        case ActionType.AUTHORIZE_WAIVER_RELEASE: {
            let key = action.value as string;

            let updatedWaiver = _.assign({}, state[key], { authorize: true });

            return _.assign({}, state, {
                [key]: updatedWaiver
            });
        }
        case ActionType.DEAUTHORIZE_WAIVER_RELEASE: {
            let key = action.value as string;

            let updatedWaiver = _.assign({}, state[key], { authorize: false });

            return _.assign({}, state, {
                [key]: updatedWaiver
            });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/step-four-reducer.ts